import { gameiomModel } from "gameiom/model/gameiom-model";
import { FooterComponent, FooterComponentConfig } from "slotworks/components/footer/footer-component";
import { SymbolFooterComponent, SymbolFooterComponentConfig } from "slotworks/components/footer/symbol-footer-component";

export class AgsSymbolFooterComponent extends FooterComponent {
    constructor(config?: Partial<FooterComponentConfig>) {
        super(config);
    }

    public getForceCreditMode(): boolean {
        return !gameiomModel.displayCurrency || gameiomModel.shouldDisplayCredits();
    }
}